import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId:    process.env.REACT_APP_AZURE_AD_CLIENT_ID,
    authority:   `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID}`,
    redirectUri: window.location.origin,
  },
  cache: { cacheLocation: 'sessionStorage', storeAuthStateInCookie: false },
};

export const loginRequest = { scopes: ['openid', 'profile', 'User.Read'] };

const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
